export default __webpack_public_path__ + "static/networks-7a2271e4400467d6d60cb915ffada242.png";